//
import { RForm } from '@/components/reusable_components/next'

//
import PchPurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import TranslatorService from '@/services/translator'
import PchPurchaseInvoiceCreateFields from '@/views/Purchase/PchPurchaseInvoice/update/fields'

//
export default {
  name: 'pch-purchase-invoice-update',
  components: {
    RForm,
  },
  computed: {
    formProps() {
      return {
        editable: false,
        fields: PchPurchaseInvoiceCreateFields,
        title: this.title,
      }
    },
    title() {
      return `Factura de compra #${this.$route.params.id}`
    },
  },
  data() {
    return {
      pchPurchaseInvoice: {
        selected: [],
      },
    }
  },
  methods: {

    /**
     * Go to purchase invoice list after update invoice
     */
    setPchPurchaseInvoice(pchPurchaseInvoice) {
      this.pchPurchaseInvoice = pchPurchaseInvoice.reset()
    },

    /**
     * Reset the update purchase invoice form
     */
    reset() {
      PchPurchaseInvoiceModel
        .include([
          'pch_detail_purchase_invoices.wh_product',
          'pch_detail_purchase_invoices.wh_product_service',
          'pch_purchase_order_has_invoice_numbers',
        ].join(','))
        .find(this.$route.params.id)
        .then(this.setPchPurchaseInvoice)
    },

    /**
     * Set form wait state
     * @param {*} value 
     */
    toWait(value = false) {
      return this
        .$refs
        .form
        .setWait(value)
    }
  },
  beforeMount() {
    this.reset()
  },
  mounted() {
    this.setTitle(this.title)
  },
}